// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0

import Vue from "vue";
import App from "./App.vue";
import i18n from "@/plugins/i18n/index";
import router from "@/plugins/router/index";
import Rollbar from "rollbar";

Vue.config.productionTip = false;
Vue.prototype.$rollbar = new Rollbar({
  accessToken: process.env.VUE_APP_ROLLBAR_ACCESS_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled: true,
  codeVersion: "1.0.0",
  nodeSourceMaps: true,
  captureIp: true,
  environment: "production"
});

new Vue({
  i18n,
  router: router(i18n),
  render: h => h(App)
}).$mount("#app");
